import './App.css';
import FanGraphChartJS from './FanGraphChartJS';

function App() {
  return (
    <div className="App">
      <FanGraphChartJS />
    </div>
  );
}

export default App;
